<template>
	<div class="fields">
		<form class="form" @submit.prevent="submit">

			<field v-bind="{label: 'navn'}" v-model="data.name"/>
			<field v-bind="{label: 'email', type: 'email'}" v-model="data.email"/>
			<field v-bind="{label: 'virksomhed', disabled: true}" v-model="resellerName"/>
			<field v-bind="{label: 'password'}"><password/></field>

			<div class="bottom">
				<div class="saved" v-if="saved">Dine ændringer er gemt</div>
				<btn type="submit" tag="button" v-bind="{loading}">Gem</btn>
			</div>
		</form>
	</div>
</template>

<script>
import {get, pick} from "lodash";
import field from "./field.vue";
import btn from "@/components/button.vue";
import password from "./password.vue";

export default {
	components: {field, btn, password},
	data() {
		return {
			saved: false,
			loading: false,
			data: pick(this.$store.getters["user/data"], ["name", "email", "reseller.name"])
		}
	},
	computed: {
		resellerName: (t) => get(t.data, "reseller.name")
	},
	methods: {
		async submit() {
			this.loading = true;
			await this.$store.dispatch("user/save", {payload: pick(this.data, ["name", "email"])});
			this.loading = false;
			this.saved = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.fields {
	background-color: $white1;
	width: 100%;
	margin-right: 22px;
	min-height: 425px; // if no employee on side

	@include res(tablet) {
		margin-right: 0;
		margin-bottom: 43px;
	}

	.form {
		height: 100%;
		display: flex;
		flex-wrap: wrap;

		@include res(tablet) {
			height: 500px;
		}

		@include res(mobile) {
			padding: 49px 27px;
			height: auto;
		}

		.bottom {
			width: 100%;
			height: percentage(1/3);
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.button {
				margin-right: 2em;
			}

			.saved {
				margin-right: 2em;
				font-size: 14px;
				color: $green1;
			}
		}
	}
}
</style>
